import "@progress/kendo-theme-fluent/dist/all.scss";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.scss";
import { ToastProvider } from "./lib/ToastProvider";
import reportWebVitals from "./reportWebVitals";
import routes from "./routes";
import { store } from "./store/store";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const router = createBrowserRouter(routes);

root.render(
  <Provider store={store}>
    <ToastProvider>
      <QueryClientProvider client={queryClient}>
        {/* <ReactQueryDevtools initialIsOpen={true} /> */}
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ToastProvider>
  </Provider>
);

serviceWorkerRegistration.register();

reportWebVitals();
